/*
 * Combobox: widgets that combine dropdown functionality with auto-complete,
 * using selectize.js and whatever else is useful.
 */

(function (c2, _) {
  'use strict';

  /*
   * Chain two selectized controls together.
   *
   * Usage:
   *   c2.combobox.chain('#select1', '#select2', '/s2-data/<%=value%>/',
   *                     {valueField: 'id', labelField: 'name'})
   *
   * Args:
   *   select1 & select2: selectors for the 2 select elements
   *   dataUrl: string for URL from which the 2nd combobox will be loaded,
   *            in lodash.template format and with optional 'value' placeholder,
   *            which will be the value of the first combobox.
   *            GETing the URL should return a JSON list of option objects like:
   *                [{'field-name-1': 'value-1', 'field-name-2': 'value-2'}, ...]
   *   s2options: options object for the select2 selectize.
   *       Specify at least the valueField name, probably also the labelField.
   *       If not specified, the sort and search fields default to using the user-visible
   *       field.
   *       sortField: object or list of objects to control option sorting.
   *           (see https://github.com/brianreavis/sifter.js#sifterjs)
   *       searchField: name or list of field names to search as user types.
   */
  function chain(select1, select2, dataUrl, s1options, s2options) {
      var $select1 = $(select1);
      var $select2 = $(select2);
      var selectize2;
      var urlTemplate = _.template(dataUrl);

      // Set defaults for sorting and searching by what the user sees
      // (labelField or valueField).
      var defaultLabelField = s2options.labelField || s2options.valueField || undefined;
      var selectize2DefaultOptions = {
        labelField: defaultLabelField,
        sortField: {
          field: defaultLabelField,
          direction: 'asc'
        },
        searchField: [defaultLabelField]
      };
      _.defaults(s2options, selectize2DefaultOptions);

      c2.selectize(select2, s2options);
      selectize2 = $select2[0].selectize;

      /* This is from the selectize docs
       * (https://github.com/brianreavis/selectize.js/blob/master/examples/cities.html),
       * but with the addition of rendering the microtemplate for the URL given
       * the value of the first select.
       */
      var xhr;
      function loadS2(value, callback, options) {
          options = _.defaults(options || {}, {
              focusOnLoad: true
          });

          xhr && xhr.abort();
          var url = urlTemplate({value: value});
          xhr = $.ajax({
              url: url,
              success: function(results) {
                  selectize2.enable();
                  callback(results);
                  if (options.focusOnLoad) {
                      selectize2.focus();
                  }
              },
              error: function() {
                  callback();
              }
          });
      }

      /*
       * Hook up the change handler to reload s2 when s1 changes.
       */

      // A Selectize onChange callback for triggering the loading of values for
      // the second select when the first select is changed.
      // https://github.com/brianreavis/selectize.js/blob/master/docs/usage.md#callbacks
      function onSelectize1Change(value, options) {
          if (!value.length) return;
          selectize2.disable();
          selectize2.clearOptions();
          selectize2.load(function(callback) {
              loadS2(value, callback, options);
          });
      }

      c2.selectize(select1, _.defaults(s1options, {
          onChange: onSelectize1Change
      }));


      /*
       * Initialize s2 if s1 has an initial value; otherwise disable.
       */
      selectize2.disable();
      var select1Val = $select1.val();
      if (select1Val) {
          onSelectize1Change(select1Val, {focusOnLoad: false});
      }
  }

  c2.combobox = {
    chain: chain
  };

})(window.c2, window._);
